import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import "../../css/search-mail/Main.css";

const Main = () => {
  const navigate = useNavigate();
  const [checkboxes, setCheckboxes] = useState({
    checkbox1: false,
    checkbox2: false,
  });

  const [selectedRadio, setSelectedRadio] = useState(null); // Tracks the selected radio button

  const handleCheckboxChange = (name) => {
    setCheckboxes((prev) => ({
      ...prev,
      [name]: !prev[name],
    }));
  };

  const handleRadioChange = (value) => {
    setSelectedRadio(value);
  };

  const [labelText, setLabelText] = useState("Default Label Text");

  const handleButtonClick = (text) => {
    setLabelText(text);
  };

  const totalItems = 250;
  const itemsPerPage = 3;
  const currentPage = 1;
  const totalPages = Math.ceil(totalItems / itemsPerPage);

  const handlePageChange = (pageNumber) => {
    if (pageNumber < 1 || pageNumber > totalPages) return;
    onPageChange(pageNumber);
  };

  const handleNext = () => {
    if (currentPage < totalPages) {
      onPageChange(currentPage + 1);
    }
  };

  const handlePrevious = () => {
    if (currentPage > 1) {
      onPageChange(currentPage - 1);
    }
  };

  const onPageChange = (pageNumber) => {
    pageNumber = pageNumber;
  };

  // Pagination logic to determine which pages to display
  const getPageNumbers = () => {
    const pages = [];
    if (totalPages <= 4) {
      // If there are 4 or fewer pages, display all pages
      for (let i = 1; i <= totalPages; i++) {
        pages.push(i);
      }
    } else {
      // If there are more than 4 pages, use ellipsis
      if (currentPage <= 3) {
        // Show first pages and last page
        for (let i = 1; i <= 3; i++) {
          pages.push(i);
        }
        pages.push("...");
        pages.push(totalPages);
      } else if (currentPage >= totalPages - 2) {
        // Show first page and last few pages
        pages.push(1);
        pages.push("...");
        for (let i = totalPages - 2; i <= totalPages; i++) {
          pages.push(i);
        }
      } else {
        // Show first page, '...', middle pages, and '...'
        pages.push(1);
        pages.push("...");
        for (let i = currentPage - 1; i <= currentPage + 1; i++) {
          pages.push(i);
        }
        pages.push("...");
        pages.push(totalPages);
      }
    }
    return pages;
  };

  const pageNumbers = getPageNumbers();

  const [data, setData] = useState([
    {
      isAttachment: true,
      id: "LTGEN-EMAIL-021523",
      subject:
        "PM210012-LTG530-RD-WIR-CIV-00606 to PM210012-LTG530-RD-WIR-CIV-00607, PM210012-LTG530 -SOHL-WIR-CIV-00788 to PM210012-LTG530-SOHL-WIR-CIV-00790-WIR FOR DATE: 25-06-2025",
      date: "24-06-25",
      from: "Document Control Neom Generation",
      fromOrganization: "LARSEN & TOUBRO SAUDI ARABIA LLC",
      toOrganization: "Air Products EPC",
      recepients: "Hafez Fares",
      status: "N/A",
      type: "Email",
    },
    {
      isAttachment: true,
      id: "LTGEN-EMAIL-021523",
      subject:
        "PM210012-LTG530-RD-WIR-CIV-00606 to PM210012-LTG530-RD-WIR-CIV-00607, PM210012-LTG530 -SOHL-WIR-CIV-00788 to PM210012-LTG530-SOHL-WIR-CIV-00790-WIR FOR DATE: 25-06-2025",
      date: "24-06-25",
      from: "Document Control Neom Generation",
      fromOrganization: "LARSEN & TOUBRO SAUDI ARABIA LLC",
      toOrganization: "Air Products EPC",
      recepients: "Hafez Fares",
      status: "N/A",
      type: "Email",
    },
    {
      isAttachment: true,
      id: "LTGEN-EMAIL-021523",
      subject:
        "PM210012-LTG530-RD-WIR-CIV-00606 to PM210012-LTG530-RD-WIR-CIV-00607, PM210012-LTG530 -SOHL-WIR-CIV-00788 to PM210012-LTG530-SOHL-WIR-CIV-00790-WIR FOR DATE: 25-06-2025",
      date: "24-06-25",
      from: "Document Control Neom Generation",
      fromOrganization: "LARSEN & TOUBRO SAUDI ARABIA LLC",
      toOrganization: "Air Products EPC",
      recepients: "Hafez Fares",
      status: "N/A",
      type: "Email",
    },
  ]);

  const [searchTerms, setSearchTerms] = useState({ id: "" });

  const handleSearchChange = (field, value) => {
    setSearchTerms((prev) => ({
      ...prev,
      [field]: value,
    }));
  };

  const filteredData = data.filter((row) =>
    row.id
      .toString()
      .toLowerCase()
      .includes(searchTerms.id.toString().toLowerCase())
  );

  // State to track the currently selected label
  const [selected, setSelected] = useState("All");

  const handleLabelClick = (label) => {
    // Update the state with the clicked label
    setSelected(label);
  };

  const [rows, setRows] = useState(
    Array.from({ length: 1 }, (_, rowIndex) =>
      Array.from({ length: 24 }, (_, colIndex) => ({
        content: `Row ${rowIndex + 1}, Col ${colIndex + 1}`,
        isSelected: false, // Checkbox state
      }))
    )
  );

  // Handle "Select All" checkbox
  const handleSelectAll = (isChecked) => {
    setRows((prevRows) =>
      prevRows.map((row) =>
        row.map((cell, colIndex) =>
          colIndex === 0 ? { ...cell, isSelected: isChecked } : cell
        )
      )
    );
  };

  // Handle individual row checkbox
  const handleRowCheckboxChange = (rowIndex, isChecked) => {
    setRows((prevRows) =>
      prevRows.map((row, rIndex) =>
        rIndex === rowIndex
          ? row.map((cell, colIndex) =>
              colIndex === 0 ? { ...cell, isSelected: isChecked } : cell
            )
          : row
      )
    );
  };

  // Check if all rows are selected
  const isAllSelected = rows.every((row) => row[0].isSelected);

  return (
    <div className="search-mail">
      <div className="title">
        <div className="sub-title">
          <div className="text1">Search - Mail</div>
          <div className="text2">Tell us what you think</div>
        </div>
        <div className="right-buttons">
          <div className="button1">
            <div className="saved">Saved Searches</div>
            <div className="icon-arrow">
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="18"
                height="18"
                fill="none"
                stroke="currentColor"
                strokeWidth="2"
                viewBox="0 0 18 18"
              >
                <path d="M6 9l6 6 6-6" />
              </svg>
            </div>
          </div>
          <div className="button2">Save</div>
        </div>
      </div>
      <div className="panel-container">
        <div className="select-type">
          {["All", "Inbox", "Sent", "Draft"].map((label) => (
            <label
              key={label}
              className={label === selected ? "current-label" : ""}
              onClick={() => handleLabelClick(label)}
            >
              {label}
            </label>
          ))}
        </div>
        <div className="select-boxes">
          <div className="seperator-with-border">
            <label>
              <input
                type="checkbox"
                checked={checkboxes.checkbox1}
                onChange={() => handleCheckboxChange("checkbox1")}
              />
              My Mail Only
            </label>
          </div>
          <div className="seperator-with-border">
            <label>
              <input
                type="checkbox"
                checked={checkboxes.checkbox2}
                onChange={() => handleCheckboxChange("checkbox2")}
              />
              My Unread
            </label>
          </div>

          <div className="seperator">
            <div className="recipient">Recipient Type</div>
            <div className="radio-buttons">
              <div className="radio-button">
                <label>
                  <input
                    type="radio"
                    name="group1"
                    value="radio1"
                    checked={selectedRadio === "radio1"}
                    onChange={() => handleRadioChange("radio1")}
                  />
                  Any
                </label>
              </div>
              <div className="radio-button">
                <label>
                  <input
                    type="radio"
                    name="group1"
                    value="radio2"
                    checked={selectedRadio === "radio2"}
                    onChange={() => handleRadioChange("radio2")}
                  />
                  To
                </label>
              </div>
              <div className="radio-button">
                <label>
                  <input
                    type="radio"
                    name="group1"
                    value="radio3"
                    checked={selectedRadio === "radio3"}
                    onChange={() => handleRadioChange("radio3")}
                  />
                  Cc
                </label>
              </div>
            </div>
          </div>
        </div>

        <div className="global-search-bar">
          <div className="search-bar-container">
            <div className="search-icon-container">
              <div className="search-icon">
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="20"
                  height="20"
                  viewBox="0 0 24 24"
                  fill="none"
                  stroke="#000000" /* Icon color */
                  strokeWidth="2"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                >
                  <circle cx="11" cy="11" r="8"></circle>
                  <line x1="16" y1="16" x2="22" y2="22"></line>
                </svg>
              </div>
              <div className="search-text">
                <input type="text" placeholder="Search across all mail" />
              </div>
            </div>
            <div className="search-button">Search</div>
          </div>
          <div className="search-labels">
            <div className="clear">Clear all</div>
          </div>
        </div>

        <div className="search-results">
          <div className="search-results-header">
            <div className="buttons">
              <div className="button-group">
                <button onClick={() => navigate("/new-mail")}>New Mail</button>
                <button onClick={() => handleButtonClick("Button 2 Clicked")}>
                  Export to Excel
                </button>
                <button onClick={() => handleButtonClick("Button 3 Clicked")}>
                  Add/Remove Column
                </button>
                <button onClick={() => handleButtonClick("Button 4 Clicked")}>
                  Advanced Search
                </button>
              </div>
            </div>
          </div>

          <div className="table-container">
            <table
              style={{
                borderCollapse: "collapse",
                textAlign: "left",
                backgroundColor: "white",
                fontSize: "14px",
              }}
            >
              <thead style={{ backgroundColor: "#ebebeb" }}>
                <tr>
                  <th
                    style={{
                      padding: "10px 10px 2px 10px",
                      color: "gray",
                      fontWeight: "200",
                    }}
                  >
                    <input
                      type="checkbox"
                      checked={isAllSelected}
                      onChange={(e) => handleSelectAll(e.target.checked)}
                    />
                  </th>
                  <th
                    style={{
                      padding: "10px 10px 2px 10px",
                      color: "gray",
                      fontWeight: "200",
                    }}
                  >
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="16"
                      height="16"
                      fill="none"
                      stroke="currentColor"
                      strokeWidth="2"
                      viewBox="0 0 24 24"
                      className="attachment-icon"
                    >
                      <path d="M17 10l4 4-4 4-4-4 4-4zm-4 0l-4 4-4-4 4-4 4 4z" />
                    </svg>
                  </th>
                  <th
                    style={{
                      padding: "10px 10px 2px 10px",
                      color: "gray",
                      fontWeight: "200",
                    }}
                  >
                    Mail No
                  </th>
                  <th
                    style={{
                      padding: "10px 10px 2px 10px",
                      color: "gray",
                      fontWeight: "200",
                    }}
                  >
                    Subject
                  </th>
                  <th
                    style={{
                      padding: "10px 10px 2px 10px",
                      color: "gray",
                      fontWeight: "200",
                    }}
                  >
                    Date
                  </th>
                  <th
                    style={{
                      padding: "10px 10px 2px 10px",
                      color: "gray",
                      fontWeight: "200",
                    }}
                  >
                    From
                  </th>
                  <th
                    style={{
                      padding: "10px 10px 2px 10px",
                      color: "gray",
                      fontWeight: "200",
                    }}
                  >
                    From Organization
                  </th>
                  <th
                    style={{
                      padding: "10px 10px 2px 10px",
                      color: "gray",
                      fontWeight: "200",
                    }}
                  >
                    To Organization
                  </th>
                  <th
                    style={{
                      padding: "10px 10px 2px 10px",
                      color: "gray",
                      fontWeight: "200",
                    }}
                  >
                    Recepients
                  </th>
                  <th
                    style={{
                      padding: "10px 10px 2px 10px",
                      color: "gray",
                      fontWeight: "200",
                    }}
                  >
                    Status
                  </th>
                  <th
                    style={{
                      padding: "10px 10px 2px 10px",
                      color: "gray",
                      fontWeight: "200",
                    }}
                  >
                    Type
                  </th>
                </tr>
                <tr>
                  <th style={{ padding: "0px 10px 10px 10px" }}></th>
                  <th style={{ padding: "0px 10px 10px 10px" }}></th>
                  <th style={{ padding: "0px 10px 10px 10px" }}>
                    <div
                      style={{
                        display: "flex",
                        alignItems: "center",
                        border: "1px solid #ccc",
                        borderRadius: "4px",
                        padding: "2px 5px",
                        width: "100%",
                        boxSizing: "border-box",
                      }}
                    >
                      <input
                        type="text"
                        value={searchTerms.id}
                        onChange={(e) =>
                          handleSearchChange("id", e.target.value)
                        }
                        style={{
                          flex: "1",
                          border: "none",
                          outline: "none",
                          padding: "2px 5px",
                          fontSize: "14px",
                        }}
                      />
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="16"
                        height="16"
                        viewBox="0 0 24 24"
                        fill="none"
                        stroke="#999"
                        strokeWidth="2"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                      >
                        <circle cx="11" cy="11" r="8"></circle>
                        <line x1="16" y1="16" x2="22" y2="22"></line>
                      </svg>
                    </div>
                  </th>

                  <th style={{ padding: "0px 10px 10px 10px" }}>
                    <div
                      style={{
                        display: "flex",
                        alignItems: "center",
                        border: "1px solid #ccc",
                        borderRadius: "4px",
                        padding: "2px 5px",
                        width: "100%",
                        boxSizing: "border-box",
                      }}
                    >
                      <input
                        type="text"
                        value={searchTerms.name}
                        onChange={(e) =>
                          handleSearchChange("name", e.target.value)
                        }
                        style={{
                          flex: "1",
                          border: "none",
                          outline: "none",
                          padding: "2px 5px",
                          fontSize: "14px",
                        }}
                      />
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="16"
                        height="16"
                        viewBox="0 0 24 24"
                        fill="none"
                        stroke="#999"
                        strokeWidth="2"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                      >
                        <circle cx="11" cy="11" r="8"></circle>
                        <line x1="16" y1="16" x2="22" y2="22"></line>
                      </svg>
                    </div>
                  </th>
                  <th style={{ padding: "0px 10px 10px 10px" }}>
                    <div
                      style={{
                        display: "flex",
                        alignItems: "center",
                        border: "1px solid #ccc",
                        borderRadius: "4px",
                        padding: "2px 5px",
                        width: "100px",
                        boxSizing: "border-box",
                      }}
                    >
                      <input
                        type="text"
                        value={searchTerms.date}
                        onChange={(e) =>
                          handleSearchChange("date", e.target.value)
                        }
                        style={{
                          border: "none",
                          outline: "none",
                          padding: "2px 5px",
                          fontSize: "14px",
                          width: "calc(100% - 20px)",
                        }}
                      />
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="16"
                        height="16"
                        fill="none"
                        stroke="#999"
                        strokeWidth="2"
                        viewBox="0 0 24 24"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                      >
                        <rect
                          x="3"
                          y="3"
                          width="18"
                          height="18"
                          rx="2"
                          ry="2"
                        ></rect>
                        <line x1="3" y1="9" x2="21" y2="9"></line>
                        <line x1="9" y1="3" x2="9" y2="21"></line>
                      </svg>
                    </div>
                  </th>
                  <th style={{ padding: "0px 10px 10px 10px" }}>
                    <div
                      style={{
                        display: "flex",
                        alignItems: "center",
                        border: "1px solid #ccc",
                        borderRadius: "4px",
                        padding: "2px 5px",
                        width: "100px",
                        boxSizing: "border-box",
                      }}
                    >
                      <input
                        type="text"
                        value={searchTerms.from}
                        onChange={(e) =>
                          handleSearchChange("from", e.target.value)
                        }
                        style={{
                          border: "none",
                          outline: "none",
                          padding: "2px 5px",
                          fontSize: "14px",
                          width: "calc(100% - 20px)",
                        }}
                      />
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="16"
                        height="16"
                        viewBox="0 0 24 24"
                        fill="none"
                        stroke="#999"
                        strokeWidth="2"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                      >
                        <circle cx="11" cy="11" r="8"></circle>
                        <line x1="16" y1="16" x2="22" y2="22"></line>
                      </svg>
                    </div>
                  </th>
                  <th style={{ padding: "0px 10px 10px 10px" }}>
                    <div
                      style={{
                        display: "flex",
                        alignItems: "center",
                        border: "1px solid #ccc",
                        borderRadius: "4px",
                        padding: "2px 5px",
                        width: "150px",
                        boxSizing: "border-box",
                      }}
                    >
                      <input
                        type="text"
                        value={searchTerms.fromOrganization}
                        onChange={(e) =>
                          handleSearchChange("fromOrganization", e.target.value)
                        }
                        style={{
                          border: "none",
                          outline: "none",
                          padding: "2px 5px",
                          fontSize: "14px",
                          width: "calc(100% - 20px)",
                        }}
                      />
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="16"
                        height="16"
                        viewBox="0 0 24 24"
                        fill="none"
                        stroke="#999"
                        strokeWidth="2"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                      >
                        <circle cx="11" cy="11" r="8"></circle>
                        <line x1="16" y1="16" x2="22" y2="22"></line>
                      </svg>
                    </div>
                  </th>
                  <th style={{ padding: "0px 10px 10px 10px" }}>
                    <div
                      style={{
                        display: "flex",
                        alignItems: "center",
                        border: "1px solid #ccc",
                        borderRadius: "4px",
                        padding: "2px 5px",
                        width: "150px",
                        boxSizing: "border-box",
                      }}
                    >
                      <input
                        type="text"
                        value={searchTerms.toOrganization}
                        onChange={(e) =>
                          handleSearchChange("toOrganization", e.target.value)
                        }
                        style={{
                          border: "none",
                          outline: "none",
                          padding: "2px 5px",
                          fontSize: "14px",
                          width: "calc(100% - 20px)",
                        }}
                      />
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="16"
                        height="16"
                        viewBox="0 0 24 24"
                        fill="none"
                        stroke="#999"
                        strokeWidth="2"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                      >
                        <circle cx="11" cy="11" r="8"></circle>
                        <line x1="16" y1="16" x2="22" y2="22"></line>
                      </svg>
                    </div>
                  </th>
                  <th style={{ padding: "0px 10px 10px 10px" }}>
                    <div
                      style={{
                        display: "flex",
                        alignItems: "center",
                        border: "1px solid #ccc",
                        borderRadius: "4px",
                        padding: "2px 5px",
                        width: "100px",
                        boxSizing: "border-box",
                      }}
                    >
                      <input
                        type="text"
                        value={searchTerms.recepients}
                        onChange={(e) =>
                          handleSearchChange("recepients", e.target.value)
                        }
                        style={{
                          border: "none",
                          outline: "none",
                          padding: "2px 5px",
                          fontSize: "14px",
                          width: "calc(100% - 20px)",
                        }}
                      />
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="16"
                        height="16"
                        viewBox="0 0 24 24"
                        fill="none"
                        stroke="#999"
                        strokeWidth="2"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                      >
                        <circle cx="11" cy="11" r="8"></circle>
                        <line x1="16" y1="16" x2="22" y2="22"></line>
                      </svg>
                    </div>
                  </th>
                  <th style={{ padding: "0px 10px 10px 10px" }}>
                    <div
                      style={{
                        display: "flex",
                        alignItems: "center",
                        border: "1px solid #ccc",
                        borderRadius: "4px",
                        padding: "2px 5px",
                        width: "100px",
                        boxSizing: "border-box",
                      }}
                    >
                      <input
                        type="text"
                        value={searchTerms.status}
                        onChange={(e) =>
                          handleSearchChange("status", e.target.value)
                        }
                        style={{
                          border: "none",
                          outline: "none",
                          padding: "2px 5px",
                          fontSize: "14px",
                          width: "calc(100% - 20px)",
                        }}
                      />
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="16"
                        height="16"
                        fill="none"
                        stroke="#999"
                        strokeWidth="2"
                        viewBox="0 0 24 24"
                        style={{ marginLeft: "8px" }}
                      >
                        <path d="M6 9l6 6 6-6" />
                      </svg>
                    </div>
                  </th>
                  <th style={{ padding: "0px 10px 10px 10px" }}>
                    <div
                      style={{
                        display: "flex",
                        alignItems: "center",
                        border: "1px solid #ccc",
                        borderRadius: "4px",
                        padding: "2px 5px",
                        width: "100px",
                        boxSizing: "border-box",
                      }}
                    >
                      <input
                        type="text"
                        value={searchTerms.type}
                        onChange={(e) =>
                          handleSearchChange("type", e.target.value)
                        }
                        style={{
                          border: "none",
                          outline: "none",
                          padding: "2px 5px",
                          fontSize: "14px",
                          width: "calc(100% - 20px)",
                        }}
                      />
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="16"
                        height="16"
                        fill="none"
                        stroke="#999"
                        strokeWidth="2"
                        viewBox="0 0 24 24"
                        style={{ marginLeft: "8px" }}
                      >
                        <path d="M6 9l6 6 6-6" />
                      </svg>
                    </div>
                  </th>
                </tr>
              </thead>
              <tbody>
                {filteredData.map((row) => (
                  <tr key={row.id} style={{ borderTop: "1px solid #ccc" }}>
                    <td style={{ padding: "10px" }}>
                      <input
                        type="checkbox"
                        checked={false}
                        onChange={(e) =>
                          handleRowCheckboxChange(row.id, e.target.checked)
                        }
                      />
                    </td>
                    <td style={{ padding: "10px" }}>
                      {row.isAttachment ? (
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          width="16"
                          height="16"
                          fill="none"
                          stroke="#999"
                          strokeWidth="2"
                          viewBox="0 0 24 24"
                          className="attachment-icon"
                        >
                          <path d="M17 10l4 4-4 4-4-4 4-4zm-4 0l-4 4-4-4 4-4 4 4z" />
                        </svg>
                      ) : (
                        <span>&nbsp;</span> // Empty space when not an attachment
                      )}
                    </td>
                    <td style={{ padding: "10px" }}>{row.id}</td>
                    <td style={{ padding: "10px" , cursor: "pointer" }}>
                      <a onClick={() => navigate("/view-mail")} >
                        {row.subject}
                      </a>
                    </td>
                    <td style={{ padding: "10px" }}>{row.date}</td>
                    <td style={{ padding: "10px" }}>{row.from}</td>
                    <td style={{ padding: "10px" }}>{row.fromOrganization}</td>
                    <td style={{ padding: "10px" }}>{row.toOrganization}</td>
                    <td style={{ padding: "10px" }}>{row.recepients}</td>
                    <td style={{ padding: "10px" }}>{row.status}</td>
                    <td style={{ padding: "10px" }}>{row.type}</td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
          <div className="pagination-container">
            <div className="pagination-info">
              <div className="total-items">
                Total Items: {totalItems} | Items per Page: {itemsPerPage}
              </div>
              <div className="current-page">
                Current Page: {currentPage} of {totalPages}
              </div>
            </div>
            <div className="buttons">
              <div>
                <div className="pagination">
                  <button onClick={handlePrevious} disabled={currentPage === 1}>
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="12"
                      height="12"
                      fill="none"
                      stroke="currentColor"
                      strokeWidth="2"
                      viewBox="0 0 24 24"
                      className="previous-icon"
                    >
                      <path d="M15 18l-6-6 6-6" />
                    </svg>
                  </button>

                  {pageNumbers.map((page, index) => {
                    if (page === "...") {
                      return (
                        <button key={index} disabled className="ellipsis">
                          ...
                        </button>
                      );
                    }
                    return (
                      <button
                        key={page}
                        onClick={() => handlePageChange(page)}
                        className={page === currentPage ? "active" : ""}
                      >
                        {page}
                      </button>
                    );
                  })}

                  <button
                    onClick={handleNext}
                    disabled={currentPage === totalPages}
                  >
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="12"
                      height="12"
                      fill="none"
                      stroke="currentColor"
                      strokeWidth="2"
                      viewBox="0 0 24 24"
                      className="next-icon"
                    >
                      <path d="M9 18l6-6-6-6" />
                    </svg>
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Main;
